<template>
  <main class="album-notice">
    <section class="album-notice-content" role="status" aria-live="polite">
      <div class="album-notice-icon" aria-hidden="true">
        <svg viewBox="0 0 64 64" fill="none"><path d="M32 17c-7-5-16-6-23-3v34c7-3 16-2 23 3 7-5 16-6 23-3V14c-7-3-16-2-23 3Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M32 17v34M16 23l9 2M16 31l9 2M39 25l9-2M39 33l9-2" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
      </div>
      <h1>画册暂时无法访问</h1>
      <p class="album-notice-message">{{ message }}</p>
      <button class="album-notice-retry" type="button" @click="$emit('retry')">重试</button>
      <p class="album-notice-help">若仍无法访问，请联系画册管理员</p>
    </section>
  </main>
</template>

<script>
export default {
  props: {message: {type: String, default: '请检查访问链接后重试'}}
}
</script>

<style scoped>
.album-notice { min-height:100vh; min-height:100dvh; box-sizing:border-box; display:flex; align-items:center; justify-content:center; padding:32px 24px; background:#f7f9f8; color:#263832; }
.album-notice-content { width:100%; max-width:360px; text-align:center; }
.album-notice-icon { width:96px; height:96px; margin:0 auto 28px; border-radius:50%; background:#e6f3ed; color:#26976b; display:flex; align-items:center; justify-content:center; }
.album-notice-icon svg { width:52px; height:52px; }
.album-notice h1 { margin:0 0 14px; font-size:22px; font-weight:600; line-height:1.5; }
.album-notice-message { margin:0; font-size:14px; color:#6c7d75; line-height:1.8; overflow-wrap:anywhere; }
.album-notice-retry { display:block; width:100%; height:46px; margin:30px 0 18px; border:0; border-radius:8px; background:#26976b; color:#fff; font-size:15px; font-weight:500; cursor:pointer; }
.album-notice-retry:focus-visible { outline:3px solid #9bd3bc; outline-offset:3px; }
.album-notice-help { margin:0; font-size:12px; color:#9aa69f; line-height:1.8; }
</style>



// WEBPACK FOOTER //
// src/components/AlbumAccessNotice.vue